module.exports = __webpack_public_path__ + "img/aiLogo.4f33f765.png";